import { ChangeEvent, ComponentPropsWithoutRef, forwardRef } from 'react';
import { Stack } from '@mui/material';
import { TextField } from 'melp-design/components';
import styles from './color-input.module.css';

interface ColorInputProps {
  value: string;
  onChange: (value: string) => void;
}

type Props = Omit<
  ComponentPropsWithoutRef<typeof TextField>,
  'type' | 'multiline' | 'secure' | 'emoji' | keyof ColorInputProps
> &
  ColorInputProps;

export const ColorInput = forwardRef<HTMLInputElement, Props>(
  ({ value, onChange, ...textInputProps }, ref) => {
    const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) =>
      onChange(target.value);

    return (
      <Stack flexDirection="row" alignItems="center" gap={1}>
        <input
          type="color"
          value={value}
          onChange={handleChange}
          className={styles.input}
        />
        <TextField
          {...textInputProps}
          value={value}
          onChange={handleChange}
          sx={{ width: '100%' }}
          ref={ref}
        />
      </Stack>
    );
  },
);

ColorInput.displayName = 'ColorInput';
